// extracted by mini-css-extract-plugin
module.exports = {"main":"AnalyticsSectionsSideBar_main__1M3Im","headerTitle":"AnalyticsSectionsSideBar_headerTitle__2018m"};